module.exports = __webpack_public_path__ + "img/1392199580.33b8731f.jpg";